
import { defineComponent } from "vue"
import CardLanguagesIndex from "@/components/card_languages/Index.vue"

export default defineComponent({
  components: {
    CardLanguagesIndex
  }
})
